import { styled } from 'styled-components';
import { Typography } from '@altibox/design-system-component-lib';

export interface StyledDescriptionProps {
    $highlighted?: boolean;
}

export const StyledDescription = styled(Typography)<StyledDescriptionProps>`
    font-weight: ${({ $highlighted }) => ($highlighted ? 'bold' : 'normal')};
`;
